import { render, staticRenderFns } from "./Municipios.vue?vue&type=template&id=24882fe8&"
import script from "./Municipios.vue?vue&type=script&lang=js&"
export * from "./Municipios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports